import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookingShell from "./components/BookingShell.tsx";
import Cancel from "./pages/Cancel.tsx";
import Success from "./pages/Success.tsx";
import NotFound from "./pages/NotFound.tsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:slug/cancel/:token" element={<Cancel />} />
        <Route path="/:slug/success" element={<Success />} />
        <Route path="/:slug/*" element={<BookingShell />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
